import {ActivityIndicator, Text} from "react-native";
import Colorable from "../plugin/Colorable";

Text.text = true;
Text.colorable = Colorable.fromStyle;
ActivityIndicator.colorable = Colorable.fromProps;
